(function(konto) {
	konto.ni = {};
} (konto = window.konto));